import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import ReferralStatusPage from "@/pages/ReferralStatusPage";
import ProductPage from "@/pages/ProductPage";
import ReferralPage from "@/pages/ReferralPage";
import axios from "axios";

axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/categoria/:category" element={<CategoryPage />} />
          <Route path="/productos" element={<CategoryPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/referido/:code" element={<ReferralStatusPage />} />
          <Route path="/producto/:id" element={<ProductPage />} />
          <Route path="/referidos" element={<ReferralPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
